import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "template-add",
  "use": "template-add-usage",
  "viewBox": "0 0 119.3 94",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 119.3 94\" id=\"template-add\"><path d=\"M69.9 11.1H7.8c-4.3 0-7.8 3.5-7.8 7.8v67.3C0 90.5 3.5 94 7.8 94h62.1c4.3 0 7.8-3.5 7.8-7.8V18.9c0-4.3-3.5-7.8-7.8-7.8zm-2.6 72.5h-57V21.5h57v62.1zM20.7 47.4H57v5.2H20.7v-5.2zm0 10.3H57v5.2H20.7v-5.2zm0 10.4H57v5.2H20.7v-5.2zm0-31.1H57v5.2H20.7V37zM118.3 13.7h-12.6V1.1c0-.6-.5-1.1-1.1-1.1h-6.9c-.6 0-1.1.5-1.1 1.1v12.6H83.9c-.6 0-1.1.5-1.1 1.1v6.9c0 .6.5 1.1 1.1 1.1h12.6v12.6c0 .6.5 1.1 1.1 1.1h6.9c.6 0 1.1-.5 1.1-1.1V22.8h12.6c.6 0 1.1-.5 1.1-1.1v-6.9c.1-.6-.4-1.1-1-1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/template-add.svg
// module id = Sf4n
// module chunks = 1